import { render } from "./archivoCard.vue?vue&type=template&id=b701db50&scoped=true"
import script from "./archivoCard.vue?vue&type=script&lang=js"
export * from "./archivoCard.vue?vue&type=script&lang=js"

import "./archivoCard.vue?vue&type=style&index=0&id=b701db50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b701db50"]])

export default __exports__